/**
 * Service: ganttTransform
 */
angular.module('acme.common.service.ganttTransform', [
    'acme.common.service.calendar'
])
.service('GanttTransformService', ['CalendarService', function(CalendarService) {

    return {

        gId: 1,

        init: function() {
            return true;
        },

        ganttId: function() {
            return this.gId++;
        },

        event: function(event, transformResources) {

            var i,
                resource,
                currentResource,
                newEvent = {},
                resources = [],
                transResources = (typeof transformResources === "undefined") ? true : transformResources;

            newEvent.id = this.ganttId();
            newEvent.text = event.name;
            newEvent.eventId = event.id;

            newEvent.start_date = CalendarService.parseDate(event.startTime);

            var diff = Math.abs(newEvent.start_date - new Date(event.endTime));
            newEvent.duration = Math.floor((diff/1000)/60/15);

            newEvent.open = false;
            newEvent.progress = 1;

            newEvent.internal_id = event.id;
            newEvent.template_id = event.templateId;
            newEvent.is_event = true;
            newEvent.is_resource_add = false;

            // TODO replace if this eventually comes through the API
            newEvent.resourceIds = {};

            // Add all resources
            if ( transResources && event.hasOwnProperty('resources') ) {
                for (i = 0; i < event.resources.length; i++ ) {

                    currentResource = event.resources[i];
                    currentResource.eventId = event.id;

                    // Transform the resources that are part of this event and attach them
                    resource = this.resource(currentResource, newEvent, event.resourceDetails);
                    resources.push(resource);

                    // Cache the resource internal id for API lookup and gantt updating
                    if (resource.internal_id !== null) {
                        newEvent.resourceIds[resource.internal_id] = resource.id;
                    }
                }
            }

            return {
                event: newEvent,
                resources: resources
            };
        },

        resource: function(currentResource, newEvent, resourceDetails) {
            var newResource = {};

            // Get id and text for gantt display
            newResource.id = this.ganttId();
            newResource.text = currentResource.type;

            // Copy info from parent
            newResource.start_date = newEvent.start_date;
            newResource.duration = newEvent.duration;
            newResource.parent = newEvent.id;
            newResource.r_category = currentResource.resourceCategory;
            newResource.r_type = currentResource.type;
            newResource.request = currentResource;

            // Default settings
            newResource.progress = 1;
            newResource.is_event = false;
            newResource.is_resource_add = false;
            newResource.fulfilled = false;

            newResource.internal_id = null;

            // Create API query
            newResource.available_query = {
                resourceCategory: currentResource.resourceCategory,
                type: currentResource.type,
                resourceTemplateId: currentResource.resourceTemplateId,
                fields: currentResource.fields,
                quantity: 1
            };

            // Modify the gantt display of this resource if it has an assignment
            if ( currentResource.hasOwnProperty('resourceId') && resourceDetails.length > 0 ) {
                newResource.internal_id = currentResource.resourceId;
                newResource.fulfilled = true;

                var details = null;

                // Don't want to assume resources are in same order so...
                for ( var key in resourceDetails ) {
                    if ( resourceDetails.hasOwnProperty(key) ) {
                        if ( resourceDetails[key].id == currentResource.resourceId ) {
                            details = resourceDetails[key];
                        }
                    }
                }

                // Get resource details
                newResource.text = details.name + ', ' + currentResource.type;
                newResource.name = details.name;
            }

            return newResource;
        },

        owner: function(event) {
            var
                newEvent = {};

            newEvent.id = this.ganttId();
            newEvent.text = event.eventName;

            newEvent.start_date = new Date(event.startDateTime);

            var diff = Math.abs(newEvent.start_date - new Date(event.endDateTime));
            newEvent.duration = Math.floor((diff/1000)/60/15);

            newEvent.open = false;
            newEvent.progress = 1;

            newEvent.internal_id = event.eventId;
            newEvent.template_id = event.eventTemplateId;
            newEvent.is_event = true;
            newEvent.is_resource_add = false;

            return newEvent;
        }
    };

}]);